import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CenterPopup } from 'antd-mobile'
import { CloseOutline } from 'antd-mobile-icons'

import { selectJmModalVisible, setJmModalVisible } from '../../store/reducers/hotel'

import styles from './index.module.less'
import { replaceCDNDomain } from '../../utils'

export default function JmModal({ children, iconData, cls = '' }) {
    const jmModalVisible = useSelector(selectJmModalVisible)
    const dispatch = useDispatch()

    return (
        <CenterPopup
            visible={jmModalVisible}
            onClose={() => dispatch(setJmModalVisible(false))}
            closeOnMaskClick
            destroyOnClose
            bodyStyle={{
                backgroundColor: 'transparent'
            }}
            style={{
                '--min-width': '90%'
            }}
        >
            <div className={`${styles.jmModal} p10 ${cls}`}>
                {iconData && <div className={`${styles.modalIconBox}`}>
                    <div className={`${styles.iconWrapper}`}>
                        <img src={replaceCDNDomain(iconData.imageUrl)} alt={iconData.name} />
                    </div>
                </div>}

                <div className={`${styles.modalContent} jm-modal-content`}>
                    {children}
                </div>

            </div>
            <div className={styles.modalClose}>
                <CloseOutline fontSize={28} color='#fff'
                    onClick={() => {
                        dispatch(setJmModalVisible(false))
                    }} />
            </div>
        </CenterPopup>
    )
}
